<template>
  <v-container fluid>
    <PageHeading
      :text="'Организации культуры'"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-cultural-organization-new'
          }"
        >
          <v-icon class="mr-2" small> mdi-plus </v-icon>
          Добавить оргапнизацию культуры
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridCulturalOrganizations ref="grid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridCulturalOrganizations from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  name: 'PageCulturalOrganizations',
  components: {
    PageHeading,
    GridCulturalOrganizations
  },
  metaInfo () {
    return {
      title: 'Организации культуры'
    }
  },
  mixins: [gridPageInterface]
}
</script>
